import React, { Component } from 'react'
import classnames from 'classnames'
import { Col, Row } from 'react-flexbox-grid'
import Columns from '../../styles/columns'
import { push } from 'connected-react-router'
import { connect } from 'react-redux'
import { localize, getLocale } from '../../util/Localizer'
import { fetchPension } from '../../redux/actions/memberSummaryActions'
import NgrxDate from '../../util/NgrxDateHelper'
// components
import Divider from '@material-ui/core/Divider'
import TitledLabel from '../../controls/TitledLabel'
import Card from '@material-ui/core/Card'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import RBButton from '../../controls/RBButton'
import { IconCalculator } from '../../assets/images'
import Icon from '@material-ui/core/Icon'
import Tooltip from '../../controls/Tooltip'
import IconButton from '@material-ui/core/IconButton'
import Loading from '../../widgets/Loading'
import PensionStatements from './pensionWidgets/PensionStatements'
import NoServerError from '../../widgets/SubmitAClaim/NoServerError'

// styles
import { withStyles } from '@material-ui/core/styles'
import CardStyles from '../../styles/cards'
import { Colors } from '../../theme'

import ButtonStyles from '../../styles/buttons'
import IconStyles from '../../styles/icons'

class Pension extends Component {
  constructor () {
    super()
    this.handleClose = this.handleClose.bind(this)
    this.handleOpen = this.handleOpen.bind(this)
    this.state = {
      open: false,
      sessionId: '',
      pensionErrorState: null
    }
  }

  componentDidMount () {
    this.props.fetchPension(() => {
      this.setState({ pensionErrorState: null })
    }, (e) => {
      this.setState({ pensionErrorState: e })
    })
  }

  handleOpen (e) {
    e.preventDefault()
    this.setState({ open: true })
  }

  handleClose () {
    this.setState({ open: false })
  }

  renderPersonalSummary () {
    const { classes = {}, pension = {} } = this.props
    const { member = {} } = pension
    const { spouse = {}, unionMembership } = member
    const spouseName = spouse ? `${spouse.firstName} ${spouse.lastName}` : 'N/A'
    return (
      <div>
        <Card className={classnames(classes.summaryCard, classes.baseCard)}>
          <Row>
            <p className='cardTitle'>{localize('pages.pension.personalSummary')}</p>
            <Col>
              <Tooltip title={localize('pages.pension.personalSummary.tooltip')} placement="right-end">
                <IconButton className={this.props.classes.button} >
                  <Icon style={{ color: Colors.Palette.primaryTextColor }}>info</Icon>
                </IconButton>
              </Tooltip>
            </Col>
          </Row>
          <Divider />
          <Row>
            <Col {...Columns.max4}>
              <TitledLabel title='pages.pension.personalSummary.bornOn' value={member.birthdate} format='date' />
            </Col>
            <Col {...Columns.max4}>
              <TitledLabel title='pages.pension.personalSummary.spouseInfo' value={spouseName} format='text' />
            </Col>
            <Col {...Columns.max4}>
              <TitledLabel title='pages.pension.personalSummary.joinedUnion' value={unionMembership.startDate} format='date' />
            </Col>
          </Row>
        </Card>
      </div>
    )
  }

  renderPensionSummary () {
    const { classes = {}, pension = {} } = this.props
    const { totalContribution, activity } = pension
    const { contribution } = activity.current
    const { overage } = contribution
    const { hours = 0, amount = 0 } = totalContribution
    if (!pension) {
      return <div />
    } else {
      return (
        <div>
          <Card className={classnames(classes.summaryCard, classes.baseCard)}>
            <Row>
              <Col xs={12}>
                <p className='cardTitle'>{localize('pages.pension.pensionSummary')}</p>
              </Col>
            </Row>
            <Divider />
            <Row>
              <Col xs={12}>
                <Row className={classnames(classes.pensionSummaryRow)}>
                  <TitledLabel
                    preTranslatedTitle={`${localize('pages.pension.pensionSummary.totalPensionContributions')} ${NgrxDate.SetDate(new Date())}`}
                    value={amount}
                    format='currency'
                  />
                </Row><Row className={classnames(classes.pensionSummaryRow)}>
                  <TitledLabel
                    preTranslatedTitle={`${localize('pages.pension.pensionSummary.totalHoursEarned')} ${NgrxDate.SetDate(new Date())}`}
                    value={hours}
                    format='text'
                  />
                </Row>
                <Row className={classnames(classes.pensionSummaryRow)}>
                  <TitledLabel
                    title={'pages.pension.pensionSummary.overage'}
                    value={overage}
                    format='currency'
                  />
                </Row>
                <Row className={classnames(classes.pensionSummaryRow)}>
                  <TitledLabel
                    preTranslatedTitle={`${localize('pages.pension.pensionSummary.monthlyPensionEarned')} ${NgrxDate.SetDate(new Date())}*`}
                    value={pension.accruedPension}
                    format='currency'
                  />
                </Row>
                <Row className={classnames(classes.pensionSummaryRow)}>
                  <p className={'titledLabelTitle'} style={{ marginTop: '-15px', fontSize: '0.72rem' }}>{localize('pages.pension.pensionSummary.overageHelpText')}</p>
                </Row>
              </Col>
            </Row>
          </Card>
        </div>
      )
    }
  }

  renderBeneficiary (Beneficiary, k) {
    const { classes = {} } = this.props
    return (
      <Card className={classnames(classes.summaryCard, classes.baseCard)} key={k}>
        <Row>
          <Col >
            <p className='cardTitle'>{`${Beneficiary.firstName} ${Beneficiary.lastName}`}</p>
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col {...Columns.max6}>
            <TitledLabel title='pages.memberSummary.dependents.relationship' value={Beneficiary.relationship} format='text' />
          </Col>
          <Col {...Columns.max6}>
            <TitledLabel title='pages.memberSummary.dependents.birthDate' value={Beneficiary.birthdate} format='date' />
          </Col>
          <Col {...Columns.max6}>
            <TitledLabel title='pages.memberSummary.dependents.split' value={`${Beneficiary.split}%`} format='text' />
          </Col>
        </Row>
      </Card>
    )
  }

  renderPensionCalculator () {
    const { classes = {} } = this.props
    const urlToCalc = this.props.pension.calculatorUrl
    return (
      <Card className={classnames(classes.summaryCard, classes.baseCard)}>
        <Row>
          <Col xs={12}>
            <p className='cardTitle'>{localize('pages.pension.pensionCalculator')}</p>
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col xs={10}>
            <p>{localize('pages.pension.pensionCalculator.text')}</p>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <div className={classnames(classes.calcLinkContainer)}>

              <IconCalculator />
              {urlToCalc &&
                <p style={{ marginLeft: 15 }}>{localize('pages.pension.pensionCalculator.linkText')}
              &nbsp;<a className={classnames(classes.pensionLink)} onClick={() => window.open(urlToCalc)}>{localize('common.here')}</a>
                </p>
              }
            </div>
          </Col>
        </Row>
      </Card>
    )
  }

  renderLegal () {
    const actions = [
      <RBButton
        key='close'
        variant='outlined'
        label={localize('common.close')}
        onClick={this.handleClose}
      />
    ]
    const { classes = {} } = this.props
    const { content = {} } = this.props.appContent.content.pensionLegalTerms.contentItemText[getLocale()] || {}
    return (
      <div>
        <p className={classnames(classes.legal)} onClick={this.handleOpen} id='legal'>{localize('pages.pension.legal')}</p>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}>
          <DialogTitle>{localize('pages.pension.legal')}</DialogTitle>
          <DialogContent>
            <div dangerouslySetInnerHTML={{ __html: content }} />
            <DialogActions>{actions}</DialogActions>
          </DialogContent>
        </Dialog>
      </div>
    )
  }

  render () {
    const { pension = {}, classes } = this.props

    if (this.state.pensionErrorState) {
      // there was an error so show it
      const { pensionErrorState = {} } = this.state
      pensionErrorState.friendlyCode = ''
      return (
        <Row start='xs'>
          <Col xs={12}>
            <div><br /><br /><NoServerError error={pensionErrorState} /></div>
          </Col>
        </Row>
      )
    }
    // A lot of this code has been commented out and will be reinstated once nexgen is ready to go
    return (
      <div>
        <br />
        {this.props.pension
          ? <div>
            {this.renderPensionCalculator()}
            {this.renderPersonalSummary()}
            {this.renderPensionSummary()}

            <br />
            <h4 className='sectionHeading'>{localize('pages.pension.beneficiaries')}</h4>
            {pension.beneficiaries.map((b, k) => {
              return this.renderBeneficiary(b, k)
            })}
            <br />
            <PensionStatements pension={pension} classes={classes} />
            <br />
            <Row >
              <Col smOffset={2} sm={8} xs={12}>
                <p className="bold">{localize('pages.pension.notice')}</p>
                <p className="bold">{localize('pages.pension.notice2')}</p>
              </Col>
            </Row>
            {this.renderLegal()}
          </div> : <Loading message={localize('common.loadingContent')} />}
      </div>
    )
  }
}

const styles = {
  ...CardStyles,
  ...ButtonStyles,
  ...IconStyles,
  statementLink: {
    display: 'flex',
    alignItems: 'center',
    color: Colors.Palette.primaryColor
  },
  legal: {
    color: Colors.Palette.primaryColor,
    textDecoration: 'underline',
    fontWeight: 'bold',
    cursor: 'pointer',
    textAlign: 'center',
    fontSize: '0.9rem'
  },
  pensionSummaryRow: {
    padding: '10px 0px'
  },
  pensionLink: {
    color: Colors.Palette.primaryColor,
    fontSize: '0.9rem',
    textDecoration: 'underline'
  },
  calcLinkContainer: {
    display: 'flex', alignItems: 'center', margin: '20px 0px'
  }
}

function mapStateToProps (state) {
  return {
    pension: state.memberSummaryReducer.pension,
    isLoading: state.memberSummaryReducer.isLoading,
    memberError: state.memberSummaryReducer.error,
    appContent: state.AppContentReducer.appContent
  }
}

const ConnectedPension = connect(mapStateToProps, { push, fetchPension })(Pension)

export default withStyles(styles)(ConnectedPension)



// WEBPACK FOOTER //
// ./src/widgets/Member/Pension.js